module.exports = "/_next/static/images/Vegetarian-Available-19d307828bfd39dae57f225bddd6e746.png";